import { IconButton } from '@mui/material';
import useSettings from 'src/hooks/useSettings';
import Iconify from '../Iconify';

const ToggleThemeButton = () => {
  const { themeMode, onToggleMode } = useSettings();

  const isDarkMode = themeMode === 'dark';

  return (
    <IconButton onClick={onToggleMode}>
      <Iconify icon={isDarkMode ? 'ph:moon-duotone' : 'ph:sun-duotone'} width={25} height={25} />
    </IconButton>
  );
};

export default ToggleThemeButton;
